import React from 'react';

const Page404 = props => (
  <div>
    <h1>404 - Page not found</h1>
    <br/>
    <p>Route not found for <code>{props.location.pathname}</code></p>
  </div>
);

export default Page404;